module.exports = __webpack_public_path__ + "static/media/preview_earning_campaigns_1.b2f092cb.svg";